import React from "react";
import { Card, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import "../css/ArticleFiles.css";
import articleFileService from "api/articleFileService";

const FILE_TYPES = [
  { key: "manuscripts", label: "Manuscript", method: "downloadManuscript" },
  { key: "tableS", label: "Tables", method: "downloadTable" },
  { key: "figureS", label: "Figures", method: "downloadFigure" },
  { key: "coverLetters", label: "Cover Letters", method: "downloadCoverLetter" },
  { key: "supplementaryS", label: "Supplementary", method: "downloadSupplementary" },
  { key: "relatedFileS", label: "Related Files", method: "downloadRelated" },
];

const ArticleFiles = ({ articleData }) => {
  console.log("article data:",articleData) ;


  const handleDownload = async (methodName, file) => {
    try {
      const res = await articleFileService[methodName](file.fileId, articleData.id);
  
      const responseText = await res.data.text();
      const json = JSON.parse(responseText);
  
      const base64Data = json.data;
      const byteCharacters = atob(base64Data);
      const byteNumbers = Array.from(byteCharacters, ch => ch.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
  
      const filename = file.fileName.replace(/\.[^/.]+$/, "");
  
      const blob = new Blob([byteArray]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", file.fileName); 
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("دانلود انجام نشد:", err);
      message.error("Error Downloading");
    }
  };
  
  

  return (
    <div className="card-container">
      <Card className="files-wrapper-card">
        {FILE_TYPES.map((type, index) => {
          const files = articleData[type.key];
          
          return (
            <div key={type.key} className="file-group">
              <h3 className="file-type-title">{type.label}</h3>

              {Array.isArray(files) && files.length > 0 ? (
                <ul style={{ paddingLeft: "1.5rem", margin: "0.25rem 0" }}>
                  {files.map((file) => (
                    <li key={file.id} className="file-item">
                      <div className="card-content">
                        <span className="file-name">{file.fileName}</span>
                        <button
                          className="download-btn"
                          onClick={() => handleDownload(type.method, file)}
                        >
                          <DownloadOutlined className="download-icon" />
                          <span className="download-text">Download</span>
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="no-data">No data</div>
              )}

              {index !== FILE_TYPES.length - 1 && (
                <div className="divider-line" style={{ margin: "1rem 0" }}></div>
              )}
            </div>
          );
        })}
      </Card>
    </div>
  );
};

export default ArticleFiles;
